'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _story = require('./mobile-components/story');

var _story2 = _interopRequireDefault(_story);

var _instagramPost = require('./mobile-components/instagram-post');

var _instagramPost2 = _interopRequireDefault(_instagramPost);

var _facebookPost = require('./mobile-components/facebook-post');

var _facebookPost2 = _interopRequireDefault(_facebookPost);

var _generic = require('./mobile-components/generic');

var _generic2 = _interopRequireDefault(_generic);

require('./mobile.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  image: {
    width: '100%',
    objectFit: 'scale-down',
    maxHeight: 140
  },
  caption: {
    textAlign: 'center'
  },
  dividerStyle: {
    borderTop: '3px solid #eee'
  }
};

var resolveAssetType = function resolveAssetType(asset) {
  if (_lodash2.default.get(asset, 'type') === 'stories') {
    return 'STORY';
  }
  if (_lodash2.default.get(asset, 'trackedAsset.platform') === 'INSTAGRAM') {
    return 'INSTAGRAM';
  }
  if (_lodash2.default.get(asset, 'trackedAsset.platform') === 'FACEBOOK') {
    return 'FACEBOOK_POST';
  }
};

var PaidReportMobileRow = function PaidReportMobileRow(_ref) {
  var asset = _ref.asset;

  var assetType = resolveAssetType(asset);
  switch (assetType) {
    case 'STORY':
      return _react2.default.createElement(_story2.default, { story: asset });
    case 'INSTAGRAM':
      return _react2.default.createElement(_instagramPost2.default, { post: asset });
    case 'FACEBOOK_POST':
      return _react2.default.createElement(_facebookPost2.default, { post: asset });
    default:
      return _react2.default.createElement(_generic2.default, { post: asset });
  }
};

PaidReportMobileRow.propTypes = {
  asset: _propTypes2.default.object.isRequired
};

exports.default = PaidReportMobileRow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/paid-report-row/mobile.js
// module id = 265
// module chunks = 1